import React, { useState, useEffect, useRef } from "react";
import logo from "../img/logoIA.png";
import useApiAsistenteIA from "../api/asistenteIA/useApiAsistenteIA";

const PALETA = {
  azul: "#0037E2",
  azulOscuro: "#0822BB",
  azulClaro: "#00A2FE",
  morado: "#AA29E2", 
  naranja: "#EBA454",
  blanco: "#FFFFFF",
  grisSuave: "#F5F7FF",
  grisBorde: "#E6E9F5",
  textoPrimario: "#1F2340",
  textoSecundario: "#586089",
};

const TablaStyles = () => (
  <style>{`
    /* Contenedor */
    .tabla-ximple.respuesta-html {
      width: 100%;
      overflow-x: auto;
      -webkit-overflow-scrolling: touch;
      font-family: inherit;
      font-size: inherit;
      line-height: inherit;
      color: inherit;
    }

    /* Tabla base */
    .tabla-ximple.respuesta-html table {
      width: 100%;
      border-collapse: collapse;
      border-spacing: 0;
      background: #fff;
      font: inherit;
      color: inherit;

      /* MUY IMPORTANTE: que el navegador calcule anchos naturalmente */
      table-layout: auto;
    }

    /* Encabezados */
    .tabla-ximple.respuesta-html thead th {
      padding: 10px 12px;
      font-weight: 600;
      background: #fff;
      text-align: left;
      border-bottom: 1px solid #E6E9F5;
      white-space: nowrap; /* headers sin salto */
    }

    /* Celdas */
    .tabla-ximple.respuesta-html tbody td {
      padding: 12px 12px;
      border-bottom: 1px solid #E6E9F5;
      vertical-align: middle;
      background: #fff;

      /* Evita cortar por letra */
      white-space: normal;       /* permite saltos */
      word-break: keep-all;      /* NO partas palabras */
      overflow-wrap: break-word; /* solo parte palabras muuuy largas */
    }

    /* Anchos mínimos por columna (ajústalos a gusto) */
    .tabla-ximple.respuesta-html table th:nth-child(1),
    .tabla-ximple.respuesta-html table td:nth-child(1) { min-width: 110px; } /* CartaPorte */
    .tabla-ximple.respuesta-html table th:nth-child(2),
    .tabla-ximple.respuesta-html table td:nth-child(2) { min-width: 110px; } /* Fecha */
    .tabla-ximple.respuesta-html table th:nth-child(3),
    .tabla-ximple.respuesta-html table td:nth-child(3) { min-width: 220px; } /* Cliente */
    .tabla-ximple.respuesta-html table th:nth-child(4),
    .tabla-ximple.respuesta-html table td:nth-child(4) { min-width: 90px;  } /* Unidad */
    .tabla-ximple.respuesta-html table th:nth-child(5),
    .tabla-ximple.respuesta-html table td:nth-child(5) { min-width: 220px; } /* Operador */
    .tabla-ximple.respuesta-html table th:nth-child(6),
    .tabla-ximple.respuesta-html table td:nth-child(6) { min-width: 90px;  } /* Caja */

    /* RUTA: clave para que NO se corte por letra */
    .tabla-ximple.respuesta-html table th:nth-child(7),
    .tabla-ximple.respuesta-html table td:nth-child(7) {
      min-width: 260px;          /* dale aire */
      white-space: normal;
      word-break: keep-all;
      overflow-wrap: break-word;
    }

    .tabla-ximple.respuesta-html table th:nth-child(8),
    .tabla-ximple.respuesta-html table td:nth-child(8) { min-width: 140px; } /* UnidadDeNegocio */
    .tabla-ximple.respuesta-html table th:nth-child(9),
    .tabla-ximple.respuesta-html table td:nth-child(9) { min-width: 160px; } /* MunicipioOrigen */
    .tabla-ximple.respuesta-html table th:nth-child(10),
    .tabla-ximple.respuesta-html table td:nth-child(10){ min-width: 160px; } /* MunicipioDestino */

    /* Última columna a la derecha (si tu tabla la usa) */
    .tabla-ximple.respuesta-html thead th:last-child,
    .tabla-ximple.respuesta-html tbody td:last-child {
      text-align: right;
      font-variant-numeric: tabular-nums;
    }

    /* Enlaces */
    .tabla-ximple.respuesta-html a {
      color: #0037E2;
      text-decoration: none;
      font-weight: 600;
    }
    .tabla-ximple.respuesta-html a:hover { text-decoration: underline; }

    /* Hover de fila */
    .tabla-ximple.respuesta-html tbody tr:hover {
      background: #F5F7FF;
      transition: background-color 0.15s ease;
    }
  `}</style>
);


const VistaIA = () => {
  const [input, setInput] = useState("");
  const [historial, setHistorial] = useState([]);
  const [loading, setLoading] = useState(false);
  const [preguntaEnProceso, setPreguntaEnProceso] = useState(null);
  const [categorias, setCategorias] = useState([]);
  const [mostrarPopup, setMostrarPopup] = useState(false);
  const [mostrarSidebar, setMostrarSidebar] = useState(false);
  const anchoMenuPrincipal = 68;
  const sidebarWidth = mostrarSidebar ? 300 : 0;
  const chatRef = useRef(null);
  const api = useApiAsistenteIA();
  const [sessionId] = useState(() => crypto.randomUUID?.() || Date.now().toString());
  const [categoriaSeleccionada, setCategoriaSeleccionada] = useState(null);

  useEffect(() => {
    if (chatRef.current) chatRef.current.scrollTop = chatRef.current.scrollHeight;
  }, [historial, loading]);

  useEffect(() => {
    (async () => {
      try {
        const cats = await api.getCategorias();
        setCategorias(cats);
        setMostrarPopup(true);
      } catch (err) {
        console.error("Error al cargar categorías:", err);
      }
    })();
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, []);

  const esSolicitudSoporte = (texto) => {
    const palabrasClave = ["error", "problema", "soporte", "falla", "no puedo", "ayuda"];
    return palabrasClave.some((p) => texto.toLowerCase().includes(p));
  };


    const handleSend = async () => {
      const q = input.trim();
      if (!q || esSolicitudSoporte(q)) return;

      const pregunta = q;
      setInput("");
      setLoading(true);
      setPreguntaEnProceso(q);

      // Helper para leer la respuesta de forma segura
      const readResponseSafely = async (res) => {
        try { return await res.json(); } catch {}
        const raw = await res.text();
        try { return JSON.parse(raw); } catch { return raw; }
      };

      // Extrae la respuesta desde n8n
      const extractMessage = (payload) => {
        const pick = (o) => {
          if (!o || typeof o !== "object") return "";
          const base = o.json && typeof o.json === "object" ? o.json : o;
          // Prioriza text, luego reply, luego output.text
          return (
            (typeof base.text === "string" && base.text.trim()) ||
            (typeof base.reply === "string" && base.reply.trim()) ||
            (base.output && typeof base.output.text === "string" && base.output.text.trim()) ||
            ""
          );
        };

        if (Array.isArray(payload)) {
          for (const it of payload) {
            const m = pick(it);
            if (m) return m;
          }
          return "";
        }
        if (typeof payload === "object" && payload !== null) return pick(payload);
        if (typeof payload === "string") return payload;
        return "";
      };

      // Convierte \n escapados en saltos reales
      const normalizeNewlines = (s) => (typeof s === "string" ? s.replace(/\\n/g, "\n") : s);

      try {
        const res = await fetch(
          "https://combustionximple.app.n8n.cloud/webhook/8c6cd9a7-ad70-4f82-b972-68f5f24a25d4/chat",
          {
            method: "POST",
            headers: {
              "Content-Type": "application/json",
              Accept: "application/json, text/plain;q=0.9, */*;q=0.8",
            },
            body: JSON.stringify({ sessionId, action: "sendMessage", chatInput: q }),
          }
        );

        if (!res.ok) {
          const errText = await res.text().catch(() => "");
          throw new Error(`HTTP ${res.status} ${res.statusText} ${errText}`);
        }

        // Lee la respuesta de n8n
        const payload = await readResponseSafely(res);
        console.log("webhook payload →", payload);

        // Extrae el texto desde el campo text del nodo AgregMensaje
        let msg = extractMessage(payload) || "Sin contenido";
        msg = normalizeNewlines(msg);

        // Si no es tabla, limpia **markdown** básico
        if (!msg.includes("<table")) {
          msg = msg.replace(/\*\*/g, "").trim();
        }

        setHistorial((prev) => [...prev, { pregunta, respuesta: msg }]);
      } catch (error) {
        console.error("Error:", error);
        setHistorial((prev) => [
          ...prev,
          { pregunta, respuesta: "Error al generar respuesta. Intenta nuevamente." },
        ]);
      } finally {
        setLoading(false);
        setPreguntaEnProceso(null);
      }
    };



  // estilos
  const sombraSuave = "0 10px 30px rgba(0, 55, 226, .18)";
  const card = {
    background: PALETA.blanco,
    border: `1px solid ${PALETA.grisBorde}`,
    borderRadius: 14,
    boxShadow: sombraSuave,
  };

  return (
    <div
      style={{
        display: "flex",
        height: "100vh",
        fontFamily: "Inter, ui-sans-serif, system-ui, -apple-system, Segoe UI, Roboto, Helvetica, Arial",
        color: PALETA.textoPrimario,      
        background:
          "radial-gradient(1200px 520px at 70% -200px, rgba(0,55,226,.18) 0%, rgba(0,162,254,.10) 45%, #FFFFFF 70%)",
      }}
    >
         <TablaStyles />
      {/* Barra lateral (azules, sin morado) */}
      <div
        style={{
          width: anchoMenuPrincipal,
          background: `linear-gradient(
            180deg,
            ${PALETA.azulClaro} 0%,
            ${PALETA.azul} 38%,
            ${PALETA.morado} 100%
          )`,
          height: "100%",
          position: "fixed",
          top: 0,
          left: 0,
          zIndex: 999,
          display: "flex",
          alignItems: "center",
          justifyContent: "center",
          boxShadow: "0 0 40px rgba(0,0,0,.18)",
        }}
      >
        <img
          src={logo}
          alt="logo"
          style={{ width: 42, height: 42, borderRadius: "50%", boxShadow: "0 6px 16px rgba(0,0,0,.25)" }}
        />
      </div>

      {/* Historial */}
      {mostrarSidebar && (
        <div
          style={{
            position: "fixed",
            top: 0,
            left: anchoMenuPrincipal,
            height: "100vh",
            width: sidebarWidth,
            background: "rgba(255,255,255,.86)",
            backdropFilter: "saturate(1.2) blur(6px)",
            borderRight: `1px solid ${PALETA.grisBorde}`,
            padding: "96px 16px 16px",
            overflowY: "auto",
            zIndex: 1001,
          }}
        >
          <h3 style={{ marginTop: 0, fontSize: 16, color: PALETA.azul }}>Historial</h3>
          {historial.map((h, i) => (
            <div key={i} style={{ ...card, padding: 12, marginBottom: 12 }}>
              <div style={{ fontSize: 13, color: PALETA.textoSecundario, marginBottom: 6 }}>Pregunta</div>
              <div style={{ fontSize: 13 }}>{h.pregunta}</div>
            </div>
          ))}
          {preguntaEnProceso && (
            <div style={{ ...card, padding: 12 }}>
              <div style={{ fontSize: 13, color: PALETA.textoSecundario, marginBottom: 6 }}>Pregunta</div>
              <div style={{ marginBottom: 10 }}>{preguntaEnProceso}</div>
              <div
                style={{
                  fontSize: 13,
                  background: PALETA.grisSuave,
                  color: PALETA.azul,
                  borderRadius: 10,
                  padding: "10px 12px",
                  fontStyle: "italic",
                }}
              >
                Generando respuesta…
              </div>
            </div>
          )}
        </div>
      )}

      {/* Contenido principal */}
      <div
        style={{
          marginLeft: anchoMenuPrincipal + (mostrarSidebar ? sidebarWidth : 0),
          flexGrow: 1,
          display: "flex",
          flexDirection: "column",
          paddingTop: 120,
          transition: "margin-left 0.28s ease",
        }}
      >
        {/* Toggle sidebar (azules) */}
        <button
          onClick={() => setMostrarSidebar(!mostrarSidebar)}
          aria-label="Abrir/cerrar historial"
          style={{
            position: "absolute",
            top: 12,
            left: anchoMenuPrincipal + 12,
            zIndex: 2000,
            border: "none",
            cursor: "pointer",
            padding: 10,
            borderRadius: 999,
            background: `linear-gradient(135deg, ${PALETA.azulOscuro}, ${PALETA.azul})`,
            color: "white",
            boxShadow: sombraSuave,
          }}
        >
          ☰
        </button>

        {/* Header */}
        <div
          style={{
            position: "fixed",
            top: 0,
            left: anchoMenuPrincipal + (mostrarSidebar ? sidebarWidth : 0),
            right: 0,
            zIndex: 1000,
            padding: "18px 20px 12px",
            display: "flex",
            flexDirection: "column",
            alignItems: "center",
            textAlign: "center",
            background:
              "linear-gradient(180deg, rgba(255,255,255,.9) 0%, rgba(255,255,255,.72) 65%, rgba(255,255,255,.6) 100%)",
            borderBottom: `1px solid ${PALETA.grisBorde}`,
            backdropFilter: "saturate(1.2) blur(6px)",
          }}
        >
          <div
            style={{
              display: "inline-flex",
              alignItems: "center",
              gap: 10,
              padding: "8px 14px",
              borderRadius: 999,
              border: `1px solid ${PALETA.grisBorde}`,
              boxShadow: "0 6px 20px rgba(0,0,0,.06)",
              background: "white",
            }}
          >
            <img src={logo} alt="logo" style={{ width: 46, height: 46, borderRadius: "70%" }} />
            <h2
              style={{
                margin: 0,
                fontSize: 18,
                fontWeight: 800,
                background: `linear-gradient(90deg, ${PALETA.azul}, ${PALETA.azulClaro})`,
                WebkitBackgroundClip: "text",
                backgroundClip: "text",
                color: "transparent",
                letterSpacing: ".2px",
              }}
            >
              Asistente Ximple
            </h2>
          </div>

          <p style={{ fontSize: 14, color: PALETA.textoSecundario, marginTop: 10, marginBottom: 0, maxWidth: 760 }}>
            Soy un asistente de IA impulsado por Ximple Intelligence que está aquí para ayudarte a navegar por Combustion.
           </p>
        </div>

        {/* Banda categoría – sin morado */}
        {categoriaSeleccionada && (
          <div
            style={{
              background: `linear-gradient(90deg, ${PALETA.azulClaro}10, ${PALETA.azul}08)`,
            borderTop: `1px solid ${PALETA.grisBorde}`,
            borderBottom: `1px solid ${PALETA.grisBorde}`,
              padding: "10px 12px",
              display: "flex",
              justifyContent: "center",
              alignItems: "center",
              gap: 10,
              fontSize: 14,
            }}
          >
            <span>
              Estás hablando con: <strong>{categoriaSeleccionada}</strong>
            </span>
            <button
              onClick={() => {
                setMostrarPopup(true);
                setCategoriaSeleccionada(null);
              }}
              style={{
                border: "none",
                background: "transparent",
                color: PALETA.azul,
                textDecoration: "underline",
                cursor: "pointer",
                fontWeight: 600,
              }}
            >
              Cambiar asistente
            </button>
          </div>
        )}

        {/* Popup categorías – botones en azules */}
        {mostrarPopup && (
          <div
            style={{
              position: "fixed",
              top: "50%",
              transform: "translate(-50%, -50%)",
              left: `calc(50% + ${(anchoMenuPrincipal + (mostrarSidebar ? sidebarWidth : 0)) / 2}px)`,
              background: "white",
              border: `1px solid ${PALETA.grisBorde}`,
              boxShadow: "0 30px 80px rgba(0,0,0,.22)",
              borderRadius: 16,
              padding: 20,
              zIndex: 1000,
              maxWidth: 460,
              width: "90%",
            }}
          >
            <button
              onClick={() => setMostrarPopup(false)}
              style={{
                position: "absolute",
                top: 10,
                right: 12,
                background: "transparent",
                border: "none",
                fontSize: 20,
                fontWeight: 700,
                color: "#8A8FA3",
                cursor: "pointer",
              }}
              aria-label="Cerrar"
            >
              ×
            </button>
            <p style={{ fontWeight: 800, marginTop: 0, fontSize: 14, marginBottom: 12, color: PALETA.textoPrimario }}>
              Selecciona el asistente con el que deseas hablar:
            </p>
            {categorias.map((c) => (
              <button
                key={c.id}
                onClick={() => {
                  setMostrarPopup(false);
                  setCategoriaSeleccionada(c.nombre);
                }}
                style={{
                  width: "100%",
                  background: `linear-gradient(135deg, ${PALETA.azulOscuro}, ${PALETA.azul})`,
                  color: "#fff",
                  fontWeight: 700,
                  border: "none",
                  borderRadius: 12,
                  padding: "12px 0",
                  fontSize: 16,
                  marginBottom: 10,
                  cursor: "pointer",
                  boxShadow: sombraSuave,
                }}
              >
                {c.nombre}
              </button>
            ))}
          </div>
        )}

        {/* Chat */}
        <div ref={chatRef} style={{ flexGrow: 1, overflowY: historial.length > 0 ? "auto" : "hidden", padding: "0 20px 110px" }}>
          {historial.map((h, i) => (
            <div key={i} style={{ marginBottom: 22, maxWidth: 980, marginInline: "auto" }}>
            
             <div style={{ fontSize: 12, color: PALETA.textoSecundario, marginBottom: 6, fontWeight: 600 }}>
                Pregunta
              </div>
              
              {/* Pregunta con borde izquierdo azul */}
              <div
                style={{
                     ...card,
                  padding: 14,
                  lineHeight: 1.55,
                  fontSize: 16,
                  wordBreak: "break-word",
                  borderLeft: `4px solid ${PALETA.azulClaro}`,
                }}
              >
                {h.pregunta}
              </div>

              <div style={{ fontSize: 12, color: PALETA.textoSecundario, marginBottom: 6, fontWeight: 600 }}>
                Respuesta
              </div>
              <div
                style={{
                  ...card,
                  padding: 14,
                  lineHeight: 1.55,
                  fontSize: 16,
                  wordBreak: "break-word",
                  borderLeft: `4px solid ${PALETA.azul}`,
                   overflowX: "auto" 
                }}
              >
                {h.respuesta && h.respuesta.includes("<table") ? (
                    <div
                        className="tabla-ximple respuesta-html"
                        dangerouslySetInnerHTML={{ __html: h.respuesta }}
                      />
                    ) : (
                      <p style={{ margin: 0 }}>{h.respuesta}</p>
                    )}
                    </div>
            </div>
          ))}

          {preguntaEnProceso && (
            <div style={{ marginBottom: 24, maxWidth: 980, marginInline: "auto" }}>
              <div style={{ fontSize: 12, color: PALETA.textoSecundario, marginBottom: 6, fontWeight: 600 }}>Pregunta</div>
              <div style={{ ...card, padding: 12, marginBottom: 12 }}>{preguntaEnProceso}</div>

              <div style={{ fontSize: 12, color: PALETA.textoSecundario, marginBottom: 6, fontWeight: 600 }}>
                Respuesta
              </div>
              <div
                style={{
                  ...card,
                  padding: 12,
                  fontStyle: "italic",
                  color: PALETA.azul,
                  background: PALETA.grisSuave,
                  border: `1px dashed ${PALETA.azulClaro}`,
                }}
              >
                Generando respuesta…
              </div>
            </div>
          )}
        </div>

        {/* Input (degradado solo en azules) */}
        <div
          style={{
            position: "fixed",
            bottom: 0,
            left: anchoMenuPrincipal + (mostrarSidebar ? sidebarWidth : 0),
            right: 0,
            padding: "12px 16px 16px",
            background:
              "linear-gradient(180deg, rgba(255,255,255,.0) 0%, rgba(255,255,255,.9) 50%, rgba(255,255,255,1) 100%)",
            borderTop: `1px solid ${PALETA.grisBorde}`,
            backdropFilter: "blur(6px)",
          }}
        >
          <div
            style={{
              display: "flex",
              alignItems: "center",
              borderRadius: 999,
              padding: 2,
              margin: "0 auto",
              maxWidth: 980,
              background: `linear-gradient(90deg, ${PALETA.azulOscuro}, ${PALETA.azul})`,
              boxShadow: sombraSuave,
            }}
          >
            <input
              type="text"
              value={input}
              onChange={(e) => setInput(e.target.value)}
              disabled={!categoriaSeleccionada}
              onKeyDown={(e) => {
                if (e.key === "Enter") handleSend();
              }}
              placeholder="Enviar un mensaje al asistente de Ximple"
              style={{
                flexGrow: 1,
                padding: "13px 16px",
                borderRadius: 999,
                border: "none",
                outline: "none",
                background: !categoriaSeleccionada ? "#EFF1F8" : "#fff",
                fontSize: 14,
              }}
            />
            <button
              onClick={handleSend}
              disabled={loading}
              style={{
                background: "transparent",
                border: "none",
                padding: "0 14px",
                color: "white",
                fontSize: 22,
                cursor: "pointer",
                display: "flex",
                alignItems: "center",
                gap: 6,
                fontWeight: 800,
              }}
              title="Enviar"
            >
              {loading ? "…" : "→"}
            </button>
          </div>

          <div
            style={{
              textAlign: "center",
              marginTop: 8,
              fontSize: 11,
              color: PALETA.textoSecundario,
            }}
          >
           Revisa siempre la exactitud de las respuestas.
           </div>
        </div>
      </div>
    </div>
  );
};

export default VistaIA;
